import Styled from 'styled-components/macro';

const Container = Styled.div`
  background-color: ${(props) => (props.purple ? props.theme.colors.primary : props.green ? props.theme.colors.secondary : props.theme.colors.white)};
`;

export default Container;
